export default "/assets/images/our-story-mobile.788b7df75e32a72d.jpg";